define('CustomMerchZone.Collection',
  [
    'SCCollection',
    'CustomMerchZone.Model'
  ],
  function (
    SCCollectionComponent,
    CustomMerchZoneModel
  ) {
    'use strict';

    var SCCollection = SCCollectionComponent.SCCollection;

    function CustomMerchZoneCollection(models, options) {
      SCCollection.call(this, models, options);

      this.model = CustomMerchZoneModel;
      this.url = function () {
        return 'services/CustomMerchZone.Service.ss';
      };
    }

    CustomMerchZoneCollection.prototype = Object.create(SCCollection.prototype);

    CustomMerchZoneCollection.prototype.constructor = CustomMerchZoneCollection;

    return 	CustomMerchZoneCollection;

  });
